import { render, staticRenderFns } from "./checkClothCount.vue?vue&type=template&id=c5aa8ef8&scoped=true&"
import script from "./checkClothCount.vue?vue&type=script&lang=js&"
export * from "./checkClothCount.vue?vue&type=script&lang=js&"
import style0 from "./checkClothCount.vue?vue&type=style&index=0&id=c5aa8ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5aa8ef8",
  null
  
)

export default component.exports